<template>
    <div class="app-inner" id="chp">
        <div class="public-btn-div flex align-cen">
            <div class="public-add" @click="addTouch">
            新增触摸屏内容
      </div>
         </div>
         <div class="p-tit-c">
            <div class="businessList-filter">
                        <div class="businessList-filter-list flex align-cen">
                     <div class="fl-le flex align-cen">
          <div class="label">触摸屏内容名称：</div>
          <div class="el-select1">
            <el-input placeholder="请输入触摸屏内容名称" v-model="search" clearable> </el-input>
          </div>
         </div>
          <div class="fl-rt flex align-cen">
          <div class="label">内容ID：</div>
          <div class="el-select1">
          <el-input placeholder="请输入内容ID" v-model="search1" clearable> </el-input>
          </div>
         </div>
              </div> 
              <div class="businessList-filter-list flex align-cen">
                    <div class="label">启用状态：</div>
                    <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio"
                    >
                    不限
                    </div>
                    <el-radio v-model="radio" label="1" @change="classSelect" >启用</el-radio>
                    <el-radio v-model="radio" label="2" @change="classSelect">禁用</el-radio>
                </div>
                   <div class="businessList-filter-list flex align-cen">
                    <div class="label">模版类型：</div>
                         <div
                    style="color: red; padding-right: 20px; cursor: pointer"
                    @click="allradio1"
                    >
                    不限
                    </div>
                    <el-radio v-model="radio1" label="1" @change="classSelect" >竖版</el-radio>
                    <el-radio v-model="radio1" label="2" @change="classSelect">横版</el-radio>
                </div>
            <div class="businessList-filter-list flex align-cen">
        <div class="label">创建时间：</div>
        <el-date-picker
          v-model="value2"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :picker-options="pickerOptions2"
          @change="classSelect"
        >
        </el-date-picker>
      </div>
     <div class="businessList-filter-list flex align-cen public-btn-small">
        <div class="public-btn-small-primary" @click="classSelect">
        搜索
        </div>
        <div class="public-btn-small-text" @click="reset">
        重置筛选条件 
        </div>
      </div>
            </div>
         </div>
     <div class="businessList-container">
        <div class="businessList-container-table">
                  <el-table
            :data="list"
            border
            style="width: 100%"
            :header-cell-style="{background:'#f7f8fa',color:'#333'}"
            >
            <el-table-column prop="id" label="内容ID" align="center" width="200">
          </el-table-column>
            <el-table-column prop="name" label="触摸屏内容名称" align="center" >
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align="center" width="200">
          </el-table-column>
          <el-table-column prop="sort" label="排序" align="center" width="100">
          </el-table-column>
          <el-table-column prop="createBy" label="创建人" align="center" width="200">
          </el-table-column>
             <el-table-column label="启用状态" align="center" width="150">
          <template slot-scope="scope">
              <div class="buStatus"  @click="changeStatus(scope)">
                <el-switch
                  v-model="scope.row.state == 0 ? false : true"
                  disabled
                >
                </el-switch>
              </div>
            </template>
          </el-table-column>
           <el-table-column
            label="操作"
            align="center"
            width="250"
            fixed="right"
            >
             <template slot-scope="scope">
                  <el-button type="text" size="small"  slot="reference" style="color:red"  @click.stop="prewiewTouch(scope.row)">预览</el-button>
                   <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="shareTouch(scope.row)">查看链接海报</el-button>
                    <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="addTouch(scope.row)">编辑</el-button>
                      <el-button type="text" size="small"  slot="reference" style="color:red" @click.stop="deletTouch(scope.row)">删除</el-button>
             </template>
          </el-table-column>
                  </el-table>
            <paginaTion :total="totalCount" @sendStatus="emitFun"></paginaTion>
        </div>
     </div>
 <el-dialog
  title="分享触摸内容"
  :visible.sync="centerDialogVisible2"
  width="440px"
  :append-to-body="true"
  center>
    <posterDraw :propImg="propImg" :propText="propText" :propType="1" :propQrcode="link" :dowloadImgName="dowloadImgName" ref="posterEmit"></posterDraw>
</el-dialog>
    </div>
</template>
<script>
import {touchList,editTouch,getTouch} from "@/api/index/index"   //分页触控屏列表、删除触摸屏内容
import paginaTion from "@/components/paginaTion/index.vue"; //分页组件
import mycomponents from "@/utils/compoments.js"
export default {
    name:'TouchScreen',
     components:{
      paginaTion,
      posterDraw:mycomponents.components.posterDraw
    },
    data() {
        return {
            propData:{},
             propImg:'https://oss.yhkz.com/2024-05-25/%E6%88%91%E7%9A%84%E8%80%83%E8%AF%95%20(2)_20240525134806.jpg',
            propText:'',
            link:'',
            centerDialogVisible2:false,
            dowloadImgName:'触摸内容',
            posterImg:'',
            search:'',
            search1:'',
            radio:'',
            radio1:'',
             value2:'',
             start_time:'',
            end_time:'',
            list:[],
            totalCount:0,
            currentPage: 1, //初始页
            PageSize: 10, //每页的数据
         pickerOptions2: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        }
    },
     activated(){
        this.getTouchList()
    },
    created () {
        
    },
    methods: {
      // 预览
      prewiewTouch(data){
        let name = data.template == 1 ? 'enTouch' : 'enTouch1'
          const newurl = this.$router.resolve({name: name, query: {id: data.id,type:1}})
           window.open(newurl.href,'_blank')
      },
        // 分享海报
        shareTouch(data){
            this.propData = data
            this.propText = data.name
            let name = data.template == 1 ? 'enTouch' : 'enTouch1'
            this.link = this.$config.prUrl + '#/webenterprise/' + name + '?id='+ data.id + '&type=1'
            this.centerDialogVisible2 = true
             this.$nextTick(() => {
                 this.$refs.posterEmit.handleChangeImg(this.propData) 
              })
        },
        // 删除触摸屏内容
        deletTouch(data){
            if(data.state == '1') return this.$util.Notifi('您需要先禁用该触摸内容后方能删除，请先禁用触摸内容','error','fa-exclamation-circle')
         this.$confirm('确认删除此项吗？删除后不可恢复，请谨慎删除。', '删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            getTouch({
              id:data.id,
              },'delete')
                .then(res => {
                 this.$util.Notifi('删除成功','success','fa-check')
                   this.getTouchList()
              })
              .catch(err => {
              })
        })
        },
        // 添加触摸屏内容
        addTouch(data){
            data.id ? this.$router.push({name:'addTouch',query:{id:data.id}}) : this.$router.push("/addTouch")
        },
        // 获取分页列表
        getTouchList(){
              let params = {
                name:this.search,
                id:this.search1,
                state:this.radio,
                template:this.radio1,
                createTimeStart:this.start_time,
                createTimeEnd:this.end_time,
                current: this.currentPage,
                size:this.PageSize,
            }
             touchList(params)
            .then(res =>{
            this.list = res.data.records
             this.totalCount = res.data.total;
            })
            .catch(err =>{})
        },
              emitFun(val,val1){
        if(val1 == "PageSize") this.PageSize = val
       if(val1 == "currentPage") this.currentPage = val
       this.getTouchList()
      },
                    // 应用状态改变
    changeStatus(e){
     if(e.row.state == 1){
           this.$confirm('确认关闭吗？', '内容禁用', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                        }).then(() => {
                        this.editPaper(e)
                        }).catch(() => {          
                        });
        }else{
            this.editPaper(e)
        }
      },
            editPaper(e){
             editTouch({
                id:e.row.id,
                state:e.row.state == 1 ? '0' : '1',
                    },'put')
                .then(res => {
                  if(res.code ==1){
                     this.$message.error(res.msg); 
                  }else{
                      this.$message.success('状态修改成功'); 
                    this.getTouchList()
                  }
                })
                .catch(err => {
                })
        },
        // 重置
        reset(){
            this.search = ""
          this.search1 = ""
          this.radio = ""
          this.radio1 = ""
          this.value2 = ""
          this.start_time = ""
          this.end_time = ""
          this.currentPage = 1
           this.getTouchList()
        },
         allradio(){
          this.radio = ""
          this.currentPage = 1
           this.getTouchList()
        },
           allradio1(){
          this.radio1 = ""
          this.currentPage = 1
           this.getTouchList()
        },
        // 筛选
        classSelect(){
            if(this.value2){
             this.start_time = this.value2[0]
            this.end_time = this.value2[1]
            }else{
              this.start_time = ""
              this.end_time = ""
            }
          this.currentPage = 1
          this.getTouchList()
        },
    }
}
</script>
<style lang="scss" scoped>
  .businessList-container {
    .businessList-container-table {
      margin-top: 20px;
      .el-switch {
        position: relative;
        z-index: 1 !important;
      }
      .el-switch.is-disabled {
        opacity: 1 !important;
      }
      .buStatus{
        width: 50px;
        margin: 0 auto;
      }
    }
    .jiange {
      margin-top: 20px;
    }
  }
    ::v-deep {
  .el-switch.is-disabled .el-switch__core {
    cursor: pointer !important;
    width: 50px !important;
  }
}
</style>